import { render, staticRenderFns } from "./OnboardingDriver.vue?vue&type=template&id=bfc423de&"
import script from "./OnboardingDriver.vue?vue&type=script&lang=js&"
export * from "./OnboardingDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports